import { AbstractControl, Validators } from "@angular/forms";

export const alphaNumericRegex = /[^a-zA-Z0-9\s]/g;//alpha numeric with space
export const alphaNumericValidation = Validators.pattern(alphaNumericRegex); //we can use it in the form validation

export function ValidateLength(control: AbstractControl) {
    if (control.value.trim().length == 0) {
        return { invalidLength: true };
    }
    return null;
}